import { render } from "./AttrDate.vue?vue&type=template&id=3ff4a4d6"
import script from "./AttrDate.vue?vue&type=script&lang=js"
export * from "./AttrDate.vue?vue&type=script&lang=js"

import "./AttrDate.vue?vue&type=style&index=0&id=3ff4a4d6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrDate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ff4a4d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ff4a4d6', __exports__)) {
    api.reload('3ff4a4d6', __exports__)
  }
  
  module.hot.accept("./AttrDate.vue?vue&type=template&id=3ff4a4d6", () => {
    api.rerender('3ff4a4d6', render)
  })

}


export default __exports__